import React, {Component} from 'react';
import {Modal} from 'antd';
import {Button} from 'react-bootstrap';

class AlertConfigurationDeleteConfirm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            deleting: false,
        }
    }

    close = () => {
        this.setState({showModal: false});
    }

    open = () => {
        this.setState({showModal: true});
    }

    deleteRule = () => {
        this.setState({deleting: true});
        this.props.onSuccess();
        this.setState({deleting: false});
        this.close();
    }

    render() {
        const deleting = this.state.deleting;
        return (
            <div>
                <Modal visible={this.state.showModal} title='Delete Rules' onOk={this.deleteRule} onCancel={this.close}
                       maskClosable={false}
                       footer={[
                           <Button key="ok" bsStyle="danger" size="large" onClick={this.deleteRule} disabled={deleting}>Delete</Button>,
                           <Button key="cancel" size="large" onClick={this.close} disabled={deleting}>Cancel</Button>,
                       ]}>
                    <div>
                        Are you sure to delete the selected Rule(s)?
                    </div>
                </Modal>
            </div>
        );
    }
}

export default AlertConfigurationDeleteConfirm;


// WEBPACK FOOTER //
// ./src/modules/dashboard/alert-configuration/AlertConfigurationDeleteConfirm.js